// 공급사 관리 섹션 URL (2026-08-26 KST 추가)
const suppliersSection = "/suppliers";

export const suppliersPath = suppliersSection;
